import React, { useState, useEffect, useRef } from "react";
import { isDeveloperDev } from "../helpers";

const testID =
  "AVL25RX2ySCp6PP6nuWEWcYWLW2mNvFBOIw7DBuOiNnuz5uOS7-yx44TXftz9VcvWJFmKQVfnLTThNmr";
const taumiPaypalID =
  "AfIbbvsHGX40ljTqSV9od0hokY3PFprQILKQi3FX9fzjvXzuU9W-f9v7PG_coAZUKOD2jcbsYVW5aZoM";

export const usePaypal = (total, description) => {
  const totalNum = Number(total);
  const paypalRef = useRef();
  const [loadState, setLoadState] = useState({ loading: false, loaded: false });
  const [error, setError] = useState(null);
  const [payDetail, setPayDetail] = useState({ paid: false, detail: [] });
  useEffect(() => {
    if (!loadState.loading && !loadState.loaded) {
      setLoadState({ loading: true, loaded: false });
      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${
        isDeveloperDev ? testID : taumiPaypalID
      }&currency=EUR&disable-funding=credit,card,giropay,sepa,sofort`;
      script.addEventListener("load", () =>
        setLoadState({ loading: false, loaded: true })
      );
      document.body.appendChild(script);
    }
    if (loadState.loaded && totalNum > 0) {
      window.paypal
        .Buttons({
          createOrder: function (data, actions) {
            // This function sets up the details of the transaction, including the amount and line item details.
            return actions.order.create({
              purchase_units: [
                {
                  description: description,
                  amount: {
                    currency_code: "EUR",
                    value: totalNum,
                  },
                },
              ],
            });
          },
          onApprove: function (data, actions) {
            // This function captures the funds from the transaction.
            return actions.order.capture().then(function (details) {
              // This function shows a transaction success message to your buyer.
              console.log(details);
              if (details.status === "COMPLETED")
                setPayDetail({ paid: true, detail: details.purchase_units });
            });
          },
          onError: (err) => {
            setError(err);
            console.error(err);
          },
        })
        .render(paypalRef.current);
      //This function displays Smart Payment Buttons on your web page.
    }
  }, [loadState, totalNum, description]);
  return [<div ref={paypalRef} />, payDetail, error];
};
